module.exports = __webpack_public_path__ + "static/img/p3-1.040b3df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mthfr/p3-1.png
// module id = L+MC
// module chunks = 0